import { ApplicationState } from './ApplicationState';
import Event from './Event';
import { LOCATION_CHANGE } from 'react-router-redux';
import FeaturesRequested from './events/FeaturesRequested';
import EstimationsImportSucceed from '../estimations/events/EstimationsImportSucceed';
import EstimationsImportRequested from '../estimations/events/EstimationsImportRequested';
import DataExportSucceeded from '../products/events/DataExportSucceeded';
import DataExportFailed from '../products/events/DataExportFailed';
import EstimationsImportFailed from '../estimations/events/EstimationsImportFailed';
import DataExportRequested from '../products/events/DataExportRequested';
import initialState from './initialState';
import OrderSetBaseOnLiabilityFailed from '../order/events/OrderSetBaseOnLiabilityFailed';
import OrderSetBaseOnLiabilitySucceed from '../order/events/OrderSetBaseOnLiabilitySucceed';
import OrderSetBaseOnLiabilityRequested from '../order/events/OrderSetBaseOnLiabilityRequested';
import OrderImportFailed from '../order/events/OrderImportFailed';
import OrderImportRequested from '../order/events/OrderImportRequested';
import OrderImportSucceed from '../order/events/OrderImportSucceed';

interface LocationChangeAction {
    type: string;
    payload: { location: { pathname: string } };
}

export default (state: ApplicationState = initialState.application, anyEvent: Event): ApplicationState => {
    switch (anyEvent.type) {
        case LOCATION_CHANGE: {
            const event = anyEvent as LocationChangeAction;
            return {
                ...state,
                prevLocation: state.location,
                location: event.payload.location.pathname
            };
        }
        case FeaturesRequested.type: {
            return {
                ...state,
                extraFeatures: (anyEvent as FeaturesRequested).features
            };
        }

        case OrderSetBaseOnLiabilityRequested.type:
        case EstimationsImportRequested.type:
        case DataExportRequested.type:
        case OrderImportRequested.type:
            return {
                ...state,
                loader: true
            };
        case OrderSetBaseOnLiabilitySucceed.type:
        case OrderSetBaseOnLiabilityFailed.type:
        case EstimationsImportSucceed.type:
        case DataExportSucceeded.type:
        case DataExportFailed.type:
        case EstimationsImportFailed.type:
        case OrderImportFailed.type:
        case OrderImportSucceed.type:
            return {
                ...state,
                loader: false
            };
    }
    return state;
};



// WEBPACK FOOTER //
// ./src/application/core/reducer.ts